import "./foundation.css";

import { moduleRegistry } from "../modules/registry";
import { createEventLog, describeFailure } from "../services/event-log";
import { createFeatureFlagService } from "../services/feature-flags";
import { mountCapabilityChecks } from "./capability-ui";
import { mountDiagnostics } from "./diagnostics-ui";
import { buildShellView } from "./model";
import { mountUpdateBand } from "./update-ui";

const appVersion = __ATLAS_VERSION__;

const root = document.querySelector<HTMLElement>("#app");

if (root === null) {
  throw new Error("Application root #app is missing");
}

const flags = createFeatureFlagService();
const eventLog = createEventLog(() => new Date().toISOString());
const view = buildShellView(moduleRegistry, flags);
const heading = document.createElement("h1");
heading.textContent = view.title;
root.replaceChildren(heading);

// R1 Step 15. Diagnostic, on by default: the tool runs on the trainee's phone
// with no developer present and must say what is wrong and how to fix it.
mountCapabilityChecks(root);

for (const moduleView of view.modules) {
  const card = document.createElement("section");
  card.dataset.kind = moduleView.kind;
  const cardHeading = document.createElement("h2");
  const body = document.createElement("p");
  cardHeading.textContent = moduleView.heading;
  body.textContent = moduleView.body;
  card.append(cardHeading, body);
  root.append(card);
  if (moduleView.kind === "content" && moduleView.mount !== undefined) {
    try {
      moduleView.mount(card);
    } catch (error: unknown) {
      card.dataset.kind = "error-card";
      cardHeading.textContent = `${moduleView.heading} could not start`;
      body.textContent =
        error instanceof Error ? error.message : "Unknown module failure.";
      // Doc 02 section 4: a failure surfaces and is recorded, never swallowed.
      eventLog.append(describeFailure(moduleView.heading, "mount", error));
    }
  }
}

mountUpdateBand(root, {
  appVersion,
  flags,
  onFailure: (failure: unknown) => {
    eventLog.append(describeFailure("update", "register", failure));
  },
});

mountDiagnostics(root, {
  activeFileHash: () => null,
  appVersion,
  flags,
  log: eventLog,
  now: () => new Date().toISOString(),
});

root.dataset.status = "ready";
